import React from 'react';
import { isObject } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import CmsElement from 'Components/Utilities/CmsElement';
import QuestionSection from "Components/Utilities/QuestionSection";

import { Loading } from "Components/Partials";
import { getRecordValue } from "Services/CmsHelpers";
import DownloadApi from 'Services/Api/Download/Download';
import { PaginationBar } from "../../Components/Partials";


export default class Gallery extends React.Component {
    /**
     * @var headers
     */
    headers = [
        '26th April 2023 - Dinner Nines',
        '27th April 2023 - Classic Cars',
        '27th April 2023 - Dinner Buitenverwachting',
        '27th April 2023 - Investors Conference One and Only',
        '27th April 2023 - Lunch Bungalow',
        '28th April 2023 - Couples Pics',
        '28th April 2023 - Dinner CapePoint Vineyard',
        '28th April 2023 - Kirstenbosch',
        '28th April 2023 - Makers Landing',
        '29th April 2023 - Dinner Cabo',
        '29th April 2023 - Lunch - Harbour House',
        '29th April 2023 - Lunch - Sevruga',
        '29th April 2023 - Lunch - The Lounger',
        '29th April 2023 - Morning Activities - Cape point',
        '29th April 2023 - Morning Activities - Catamaran',
        '29th April 2023 - Morning Activities - E Bikes',
        '29th April 2023 - Morning Activities - RIB Boats',
        '29th April 2023 - Morning Activities - Robben Island',
        '29th April 2023 - Morning Activities - Table Mountain',
        '30th April 2023 - Classic Cars',
        '30th April 2023 - Lunch Bungalow',
        '30th April 2023 - Mount Nelson',
        '30th April 2023 - Dinner Gold',
    ];

    /**
     * @var state
     * @type {{open: string}}
     */
    state = {
        open: null,
    };

    /**
     * @method handleToggleSection
     * @param section
     */
    handleToggleSection = (section) => this.setState({
        open: this.state.open === section ? null : section,
    });

    /**
     *
     * @returns {JSX.Element}
     */
    renderOpeningTextSection = () => {
        return (
            <Section>
                <p className="bmw-condenced-bold text-2xl">
                    WHAT’S IN STORE
                </p>

                <p className="bmw-condenced-bold">
                    Please browse through the below galleries to re-live some of the wonderful Cape Town memories.
                </p>
            </Section>
        );
    };

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { open } = this.state;
        return (
            <Authenticated>
                <PageHeader
                    title="Gallery"
                    imgSrc="Gallery-Banner.png"
                />

                { this.renderOpeningTextSection() }

                <Section>
                    { this.headers.map((header, key) => (
                        <div key={`header-${key}`}>
                            <div
                                className="w-full my-auto bmw-condenced-bold flex items-center justify-between cursor-pointer"
                                onClick={ () => this.handleToggleSection(header) }
                            >
                                <div>{ header }</div>

                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className={`transition duration-200 ${open === header ? 'transform rotate-180' : ''}`}
                                />
                            </div>

                            { open === header && (
                                <GalleryGrid
                                    folder={ header }
                                />
                            ) }
                        </div>
                    )) }
                </Section>

                <QuestionSection/>
            </Authenticated>
        );
    }
}

class GalleryGrid extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'gallery';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = true;

    /**
     * @var state
     */
    state = {
        working: true,
        filters: {
            folder: this.props.folder,
            per_page: 18,
        },
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working, records } = this.state;

        return (
            <>
                { working && (
                    <Loading/>
                ) }

                { !working && (
                    <>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-left">
                            { records.data?.map(data => (
                                <div key={data.id}>
                                    <img
                                        className="mx-auto my-auto transition duration-200 hover:scale-150"
                                        src={ getRecordValue(data, 'thumbnail', 'file') }
                                        decoding="async"
                                    />
                                    <div
                                        onClick={ () => this.handleSubmit(data) }
                                    >
                                        <FontAwesomeIcon
                                            icon={ faDownload }
                                            size="1x"
                                            className={ "mx-1 cursor-pointer" }
                                        />
                                    </div>
                                </div>
                            )) }
                        </div>

                        <div className="mt-5">
                            <PaginationBar
                                total={records.meta.total}
                                pageCount={records.meta.last_page}
                                page={records.meta.current_page}
                                goToPage={this.fetchRecords}
                            />
                        </div>
                    </>
                ) }
            </>
        );
    }

    /**
     * @method handleSubmit
     * @param {object} data
     * @return {Promise<*>}
     */
    handleSubmit = (data) => DownloadApi.download(getRecordValue(data, 'image').value);
}
